import postMessageToParentExtension from '../utils/postMessageToParentExtension';
import { MessageRequestTypes } from '../schema/RequestMessageTypes';

const querySearchKeysMapToAvoidCaching = {
    bo: 1,
    authredirect: 1,
    sessionid: 1,
    offline: 1,
};
const filterSearchKeys = (url, querySearchKeysMap = {}) => {
    const urlObject = new URL(url);
    const searchParamsCopy = new URLSearchParams(urlObject.search);
    searchParamsCopy?.forEach((v, k) => {
        if (querySearchKeysMap[k.toLowerCase()]) {
            urlObject.searchParams.delete(k);
        }
    });
    return urlObject.toString();
};
export default function sendLastUrlToExtension(url: string): void {
    postMessageToParentExtension({
        type: MessageRequestTypes.SetLastURL,
        payload: filterSearchKeys(url, querySearchKeysMapToAvoidCaching),
    });
}
